import { E_ADMIN_ROLE, TAdmin } from "../Types";

export enum E_LOCAL_STORAGE_KEY {
  USER = "user",
  USER_PERMISSIONS = "user_permissions"
}

export enum E_SESSION_STORAGE_KEY {
  COUNTS = "counts"
}
export enum E_STORAGE_TYPE {
  SESSION = "SESSION",
  LOCAL = "LOCAL"
}

type TStorageDefaults = {
  [E_LOCAL_STORAGE_KEY.USER]: TAdmin;
  [E_LOCAL_STORAGE_KEY.USER_PERMISSIONS]: number[];
  [E_SESSION_STORAGE_KEY.COUNTS]: Record<string, number>;
};

export const STORAGE_DEFAULTS: TStorageDefaults = {
  [E_LOCAL_STORAGE_KEY.USER]: {
    id: -1,
    username: "",
    fullName: "",
    role: E_ADMIN_ROLE.NO_ROLE,
    lastLogin: "",
    needResetPassword: false
  },
  [E_LOCAL_STORAGE_KEY.USER_PERMISSIONS]: [],
  [E_SESSION_STORAGE_KEY.COUNTS]: {}
};
export type TStorageKey = E_LOCAL_STORAGE_KEY | E_SESSION_STORAGE_KEY;
